export default __webpack_public_path__ + "static/media/phoneAccount.5c02e232.png";